// extracted by mini-css-extract-plugin
module.exports = {"Bubble":"Bubble_Bubble__2Wga8","Bubble_slide-top__3GUGp":"Bubble_Bubble_slide-top__3GUGp__1F25S","CloseButton":"Bubble_CloseButton__3ZuqT","slide-top":"Bubble_slide-top__2PVO3"};